import LiquidityRequestDetails from "./liquidity-request-details";

export default LiquidityRequestDetails;
